export default __webpack_public_path__ + "static/media/750x750 friskies.cf832bab.jpg";